"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Button = _interopRequireDefault(require("../../Buttons/Button"));

var _EmailInput = _interopRequireDefault(require("../../Inputs/EmailInput"));

var _LabeledInput = _interopRequireDefault(require("../../Inputs/LabeledInput"));

var _Form = _interopRequireDefault(require("../../FormElements/Form"));

var _FormRow = _interopRequireDefault(require("../../FormElements/FormRow"));

var _PhoneInput = _interopRequireDefault(require("../../Inputs/PhoneInput"));

var _idGenerator = require("../../../utils/idGenerator");

var _validationRules = require("../../../constants/validation/validationRules");

var _strings = require("../../../constants/strings");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function () { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var defaultFirstNameLabel = _strings.contactDetailsFormConstants.defaultFirstNameLabel,
    defaultLastNameLabel = _strings.contactDetailsFormConstants.defaultLastNameLabel,
    defaultPhoneLabel = _strings.contactDetailsFormConstants.defaultPhoneLabel,
    defaultEmailLabel = _strings.contactDetailsFormConstants.defaultEmailLabel,
    defaultSubmitButton = _strings.contactDetailsFormConstants.defaultSubmitButton;

var ContactDetailsForm = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(ContactDetailsForm, _React$PureComponent);

  var _super = _createSuper(ContactDetailsForm);

  function ContactDetailsForm(props) {
    var _this;

    _classCallCheck(this, ContactDetailsForm);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "handleChange", function (inputKey, e) {
      if (!inputKey || !Object.keys(_this.state).find(function (key) {
        return key === inputKey;
      })) {
        throw new Error('Unable to match input key to key in state');
      }

      _this.setState(_defineProperty({}, inputKey, e.target.value));
    });

    _defineProperty(_assertThisInitialized(_this), "handleSubmit", function (e) {
      if (e) {
        e.preventDefault();
      }

      var submitHandler = _this.props.submitHandler;

      if (_this.formRef.current.validateInputs().length) {
        return;
      }

      return submitHandler(_this.state);
    });

    _this.state = {
      firstName: props.firstName,
      lastName: props.lastName,
      phone: props.phone,
      email: props.email
    };
    _this.formId = (0, _idGenerator.generateId)();
    _this.formRef = _react.default.createRef();
    return _this;
  }

  _createClass(ContactDetailsForm, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$state = this.state,
          firstName = _this$state.firstName,
          lastName = _this$state.lastName,
          phone = _this$state.phone,
          email = _this$state.email;
      var _this$props = this.props,
          className = _this$props.className,
          firstNameLabel = _this$props.firstNameLabel,
          lastNameLabel = _this$props.lastNameLabel,
          phoneLabel = _this$props.phoneLabel,
          emailLabel = _this$props.emailLabel,
          submitButtonText = _this$props.submitButtonText,
          validationRules = _this$props.validationRules;
      return /*#__PURE__*/_react.default.createElement(_Form.default, {
        className: className,
        dataTestId: 'contact-details-form',
        ref: this.formRef
      }, /*#__PURE__*/_react.default.createElement(_FormRow.default, null, /*#__PURE__*/_react.default.createElement(_LabeledInput.default, {
        characterLimit: 40,
        dataTestId: 'contact-details-first-name-input',
        id: "first-name-input-".concat(this.formId),
        inputType: "text",
        label: "".concat(firstNameLabel, ":"),
        name: "First Name",
        onChange: function onChange(e) {
          return _this2.handleChange('firstName', e);
        },
        value: firstName,
        validationRules: validationRules
      }), /*#__PURE__*/_react.default.createElement(_LabeledInput.default, {
        characterLimit: 60,
        dataTestId: 'contact-details-last-name-input',
        id: "last-name-input-".concat(this.formId),
        inputType: "text",
        label: "".concat(lastNameLabel, ":"),
        name: "Last Name",
        onChange: function onChange(e) {
          return _this2.handleChange('lastName', e);
        },
        value: lastName,
        validationRules: validationRules
      })), /*#__PURE__*/_react.default.createElement(_PhoneInput.default, {
        dataTestId: 'contact-details-phone-input',
        id: "phone-input-".concat(this.formId),
        label: "".concat(phoneLabel, ":"),
        name: "phone",
        onChange: function onChange(e) {
          return _this2.handleChange('phone', e);
        },
        value: phone
      }), /*#__PURE__*/_react.default.createElement(_EmailInput.default, {
        dataTestId: 'contact-details-email-input',
        id: "email-input-".concat(this.formId),
        label: "".concat(emailLabel, ":"),
        name: "email",
        onChange: function onChange(e) {
          return _this2.handleChange('email', e);
        },
        value: email
      }), /*#__PURE__*/_react.default.createElement(_Button.default, {
        dataTestId: 'contact-details-submit-button',
        buttonType: "submit",
        onClick: this.handleSubmit
      }, submitButtonText));
    }
  }]);

  return ContactDetailsForm;
}(_react.default.PureComponent);

_defineProperty(ContactDetailsForm, "propTypes", {
  /** Styling classname */
  className: _propTypes.default.string,

  /** Initial value for first name */
  firstName: _propTypes.default.string,

  /** Label for first name field */
  firstNameLabel: _propTypes.default.string,

  /** Initial value for last name */
  lastName: _propTypes.default.string,

  /** Label for last name field */
  lastNameLabel: _propTypes.default.string,

  /** Initial value for phone number */
  phone: _propTypes.default.string,

  /** Label for phone number field */
  phoneLabel: _propTypes.default.string,

  /** Initial value for email field */
  email: _propTypes.default.string,

  /** Label for email field */
  emailLabel: _propTypes.default.string,

  /** Submission hoisting function */
  submitHandler: _propTypes.default.func.isRequired,

  /** Text for submit button */
  submitButtonText: _propTypes.default.string,

  /** Validation rules for first name / last name */
  validationRules: _propTypes.default.shape({})
});

_defineProperty(ContactDetailsForm, "defaultProps", {
  className: '',
  firstName: '',
  firstNameLabel: defaultFirstNameLabel,
  lastName: '',
  lastNameLabel: defaultLastNameLabel,
  phone: '',
  phoneLabel: defaultPhoneLabel,
  email: '',
  emailLabel: defaultEmailLabel,
  submitButtonText: defaultSubmitButton,
  validationRules: {
    BLUR: [_validationRules.REQUIRED],
    SUBMIT: [_validationRules.REQUIRED]
  }
});

var _default = ContactDetailsForm;
exports.default = _default;